import { render, staticRenderFns } from "./OneMainGallery.vue?vue&type=template&id=2918b844&scoped=true"
import script from "./OneMainGallery.vue?vue&type=script&lang=js"
export * from "./OneMainGallery.vue?vue&type=script&lang=js"
import style0 from "./OneMainGallery.vue?vue&type=style&index=0&id=2918b844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918b844",
  null
  
)

export default component.exports